/* global $ */

const print = {
  initialize() {
    $('.js-print').on('click', () => {
      window.print();
    });
  },
};

export default print;
